<template>
	<div>
		<b-table-simple responsive striped small hover table-class="mb-0">
			<b-thead>
				<b-tr>
					<b-th colspan="2"><span class="lead">Armor</span></b-th>
					<b-th :colspan="hasShield?5:4"><span class="float-right">{{armor.Name}}</span></b-th>
				</b-tr>
				<b-tr v-if="hasShield">
					<b-th colspan="2"><span class="lead">Shield</span></b-th>
					<b-th colspan="5"><span class="float-right">{{shield.Name}}</span></b-th>
				</b-tr>
			</b-thead>
			<b-tbody>
				<b-tr>
					<b-th></b-th>
					<b-th>=</b-th>
					<b-th>Base + </b-th>
					<b-th>Dex + </b-th>
					<b-th>Armor + </b-th>
					<b-th v-if="hasShield">Shield + </b-th>
					<b-th>Misc</b-th>
				</b-tr>
				<b-tr>
					<b-th scope="row">EAC</b-th>
					<b-td class="text-center table-active">{{totalArmor(armor.EAC, shield.BonusWielded, armor.Misc.EAC)}}</b-td>
					<b-td class="text-center">10</b-td>
					<b-td class="text-center">{{dexToAC()}}</b-td>
					<b-td class="text-center">{{armor.EAC}}</b-td>
					<b-td class="text-center" v-if="hasShield">{{shield.BonusWielded}}</b-td>
					<b-td class="text-center"><input class="form-control form-control-sm" v-model.number="miscEAC"></b-td>
				</b-tr>
				<b-tr>
					<b-th scope="row">KAC</b-th>
					<b-td class="text-center table-active">{{totalArmor(armor.KAC, shield.BonusWielded, armor.Misc.KAC)}}</b-td>
					<b-td class="text-center">10</b-td>
					<b-td class="text-center">{{dexToAC()}}</b-td>
					<b-td class="text-center">{{armor.KAC}}</b-td>
					<b-td class="text-center" v-if="hasShield">{{shield.BonusWielded}}</b-td>
					<b-td class="text-center"><input class="form-control form-control-sm" v-model.number="miscKAC"></b-td>
				</b-tr>
				<b-tr>
					<b-th scope="row">CM</b-th>
					<b-td class="text-center table-active">{{(totalArmor(armor.KAC, shield.BonusWielded, armor.Misc.KAC) + 8 + armor.Misc.CM)}}</b-td>
					<b-td class="text-center">8</b-td>
					<b-td class="text-center" :colspan="hasShield?3:2">+ {{totalArmor(armor.KAC, shield.BonusWielded, armor.Misc.KAC)}} <strong>KAC</strong></b-td>
					<b-td class="text-center"><input class="form-control form-control-sm" v-model.number="miscCM"></b-td>
				</b-tr>
			</b-tbody>
		</b-table-simple>
		<b-table-simple responsive striped small hover table-class="mb-0" v-if="hasArmorUpgrades">
			<b-thead>
				<b-tr>
					<b-th colspan="2"><span class="lead text-muted">Armor Upgrades</span></b-th>
				</b-tr>
			</b-thead>
			<b-tbody>
				<combat-card-upgrade v-for="(upgrade, index) in upgrades" :key="index" :index="index" :upgrade="upgrade"/>
			</b-tbody>
		</b-table-simple>
		<b-list-group flush v-if="weapons.length > 0">
			<b-list-group-item class="p-1"><span class="lead">Weapons</span></b-list-group-item>
			<combat-card-weapon v-for="(weapon, index) in weapons" :key="index" :index="index" :weapon="weapon"/>
		</b-list-group>
	</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import CombatCardUpgrade from '@/components/play/CombatCardUpgrade.vue'
import CombatCardWeapon from '@/components/play/CombatCardWeapon.vue'

export default {
	components: {
		CombatCardUpgrade,
		CombatCardWeapon,
	},
	methods: {
		dexToAC: function(){
			var dexMod = this.abilityMods.Dexterity;
			var shield = this.shield.MaxDex;
			var armor = this.armor.MaxDex;
			var maxDex = 0;
			if(this.hasShield && shield < armor){
				maxDex = shield;
			}else{
				maxDex = armor;
			}
			return ( dexMod > maxDex ? maxDex : dexMod );
		},
		totalArmor: function( armorBonus, shieldBonus, miscBonus ){
			var dexBonus = this.dexToAC();
			return 10 + dexBonus + armorBonus + shieldBonus + miscBonus;
		},
		setBonus: function(what, value) {
			let Misc = {}
			Misc[what] = value
			this.$store.commit('setCharacterProp',[
				{
					key: `Equipment.Armor[${this.currentArmor}]`,
					val: Misc,
				}
			])
		},
		...mapActions('modals', [
			'showDetails',
			'hideDetails'
		]),
	},
	computed: {
		miscEAC: {
			get: function() {
				return this.$store.state.Character.Equipment.Armor[this.currentArmor].Misc.EAC
			},
			set: function(value) {
				this.setBonus('EAC',value)
			}
		},
		miscKAC: {
			get: function() {
				return this.$store.state.Character.Equipment.Armor[this.currentArmor].Misc.KAC
			},
			set: function(value) {
				this.setBonus('KAC',value)
			}
		},
		miscCM: {
			get: function() {
				return this.$store.state.Character.Equipment.Armor[this.currentArmor].Misc.CM
			},
			set: function(value) {
				this.setBonus('CM',value)
			}
		},
		currentArmor: function(){
			return this.$store.state.Character.Current.Armor
		},
		armor: function() {
			return this.$store.state.Character.Equipment.Armor[this.currentArmor]
		},
		hasShield: function(){
			return false
		},
		shield: function(){
			return this.$store.state.Character.Equipment.Shield
		},
		weapons: function() {
			return this.$store.state.Character.Equipment.Weapons
		},
		hasArmorUpgrades: function(){
			return this.$store.getters.usedArmorUpgradeSlots.length > 0
		},
		upgrades: function() {
			return this.$store.state.Character.Equipment.Armor[this.currentArmor].Upgrades
		},
		...mapGetters([
			'currentLevel',
			'usedArmorUpgradeSlots',
		]),
		...mapGetters('character/abilityScores',[
			'abilityScores',
			'abilityMods',
		])
	}
}
</script>

<style scoped>

</style>